import React,{useContext,useEffect, useState, useRef,useCallback,useMemo} from 'react';
import { DatabaseContext } from '../../../redux/DatabaseStore';
import { useFormik } from 'formik';
import { getRequest, postRequest,deleteRequest, tabulatorGet } from '../../../api/ApiController';
import { SaveIcon, AddIcon, CopyIcon, PrintIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, SaveAndCloseIcon,EditRowIcon,PaperClipIcon,EditIcon,DeleteIcon, ActivateIcon, DeactivateIcon} from "../../svg/svgIcons";
import { Dialog } from 'primereact/dialog';
import AuthContext from '../../../components/AuthContext';
import UtilContext from '../../../components/UtilContext';
import { Splitter, SplitterPanel } from 'primereact/splitter';
import { ReactTabulator,reactFormatter } from 'react-tabulator';
import { DateTime } from "luxon";
import { Avatar } from 'primereact/avatar';
import { OverflowMenuProvider } from '../../../components/toolbar/OverflowMenu';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { PanelMenu } from 'primereact/panelmenu';
import { Checkbox } from 'primereact/checkbox';
import { Dropdown } from 'primereact/dropdown';
import IntersectionObserverWrapper from '../../../components/toolbar/IntersectionObserverWrap';
import { createArrayNavigateHandlers } from '../../../utils/arrayNavigate';
import { resetTabulatorMask } from '../../../utils/tabulatorResetMask';
import { getDateFormat } from '../../../utils/dateUtils';
import { extractSafePaginationParams, createDedupedAjaxRequest, cleanSorters, refreshProgressiveFromStart } from '../../../utils/tabulatorProgressiveLoading';
import { getPusherChannel } from '../../../utils/pusherChannel';
import { emitCalibrationCompanyCertStateMutation, CALIBRATION_COMPANY_CERT_KIND } from '../../../utils/calibrationCertificateStateSync';
import { LocaleContext } from '../../../components/LocaleContext';
import { defaultProductLogoSrc } from '../../../constants/brandingDisplay';
import { buildCanonicalPrintFooterHtml, buildCanonicalPrintHeaderHtml } from '../../../utils/printChrome';
export default function CalibrationCompanyCardDetail({calibration_company, type}) {

    const [state,dispatch] = useContext(DatabaseContext);
    const { t } = useContext(LocaleContext);
    const {setDialogText,setVisible,openFavoriteDialog,toast,setFastView,setUserMaskFilter,openFilePreview, openChosenNotificationPreferences, getUserColor, getUserInitials, formatDate} = useContext(UtilContext);
    const dateFmt = getDateFormat(state?.module_settings || []);
    const dateTimeFmt = `${dateFmt} HH:mm`;
    const {user} = useContext(AuthContext);

    const company = useMemo(
        () => state.calibration_companies?.find(c => c.id === calibration_company?.id) ?? calibration_company,
        [state.calibration_companies, calibration_company]
    );

    const [closeTab,setCloseTab] = useState(false);
    const ref = useRef(null);
    const submitRef = useRef(null);
    const overlayRef = useRef(null);
    const [formCalibrationCompanyCertificate,setFormCalibrationCompanyCertificate] = useState(calibration_company);
    const [formType, setFormType] = useState(type);
    const [showCalibrationCertificateAdd, setShowCalibrationCertificateAdd] = useState(false);

    const [markUnmark, setMarkUnmarked] = useState(true);

    const DEFAULT_COLUMNS_VISIBLE_CALIBRATION_COMPANY = { name: true, deactivation_date: true, certificate_status: true, 'responsible.name': true, required_attachment: true, description: true, created_at: true, updated_at: true };
    const [columnsVisible, setColumnsVisible] = useState({ ...DEFAULT_COLUMNS_VISIBLE_CALIBRATION_COMPANY });
    const [maskVisible, setMaskVisible] = useState(false);
const [insertCopyIcon,setInsertCopyIcon] = useState((user.permissions?.includes("edit calibration-company"))?false:true);
    const [scrollIcons,setScrollIcons] = useState((user.permissions?.includes("edit calibration-company"))?false:true);
    const [editIcon,setEditIcon] = useState(true);
    const [deleteIcon,setDeleteIcon] = useState(true);
    const [copyIcon,setCopyIcon] = useState(true);
    const [activateIcon,setActivateIcon] = useState(true);
    const [deactivateIcon,setDeactivateIcon] = useState(true);
    const [visibleDeactivate, setVisibleDeactivate] = useState(false);

    const [selectedCertificate,setSelectedCertificate] = useState(null);

    const [visibleCompanyCertificate,setVisibleCompanyCertificate] = useState(false);

    const [images,setImages] = useState('');

    const [fileList, setFileList] = useState([]);
    const fileListRef = useRef(null);

    const [updatefileList, setUpdateFileList] = useState([]);
    const updateFileListRef = useRef(null);
    const [navigationList, setNavigationList] = useState([]);

    const inFlightRef = useRef({ sig: null, promise: null });
    const completedCacheRef = useRef(new Map());
    const savedHScrollRef = useRef({ left: 0, pending: false });
    const getTable = useCallback(() => ref.current?.table ?? ref.current, []);
    const pageSizePc = useMemo(() => {
        const v = (state.module_settings || []).find(s => s.module === 'global' && s.key === 'page_size_pc')?.value;
        const n = parseInt(v, 10);
        return (Number.isFinite(n) && n > 0) ? n : 50;
    }, [state.module_settings]);
    const refreshFromStart = useCallback(() => refreshProgressiveFromStart(getTable, completedCacheRef, t('Common.LoadingData')), [getTable]);
    const captureHScroll = useCallback(() => {
        const table = getTable();
        if (!table?.rowManager?.element) return;
        savedHScrollRef.current = { left: table.rowManager.element.scrollLeft, pending: true };
    }, [getTable]);
    const restoreHScroll = useCallback(() => {
        if (!savedHScrollRef.current.pending) return;
        const table = getTable();
        if (!table?.rowManager?.element) return;
        const holder = table.rowManager.element;
        const header = table.columnManager?.contentsElement;
        const left = savedHScrollRef.current.left;
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                holder.scrollLeft = left;
                if (header) header.scrollLeft = left;
                savedHScrollRef.current.pending = false;
            });
        });
    }, [getTable]);

    const buildRequestParams = useCallback((paramsFromTabulator = {}) => {
        const extra = { ...extractSafePaginationParams(paramsFromTabulator) };
        if (extra.size == null) extra.size = pageSizePc;
        extra.type = 'calibration';
        if (calibration_company?.id != null) extra.company_id = calibration_company.id;
        const sorters = cleanSorters(paramsFromTabulator?.sorters ?? getTable()?.getSorters?.() ?? []);
        if (sorters?.length) extra.sorters = JSON.stringify(sorters);
        const t = getTable();
        const hf = t?.getHeaderFilters?.() ?? [];
        hf.forEach(f => {
            if (f?.field != null && f.value != null && String(f.value).trim() !== '') {
                extra['filter_' + f.field] = String(f.value).trim();
            }
        });
        return extra;
    }, [pageSizePc, calibration_company?.id, getTable]);

    const fetchPagedDetail = useCallback((url, merged) => {
        return tabulatorGet(url, merged).then((r) => {
            const raw = r?.data ?? [];
            const data = raw.map(c => ({
                ...c,
                certificate_status: (c.deactivation_date ? t('Status.Deactivated') : t('Status.Active'))
            }));
            return { data, last_page: r?.last_page ?? 1, total: r?.total ?? 0 };
        });
    }, []);

    const ajaxRequestFunc = useMemo(
        () => createDedupedAjaxRequest(buildRequestParams, fetchPagedDetail, inFlightRef, completedCacheRef),
        [buildRequestParams, fetchPagedDetail]
    );

    const currentCompanyId = calibration_company?.id ?? null;
    useEffect(() => {
      const channel = getPusherChannel();
      if (!channel) return;
      const DEDUPE_MS = 800;
      const lastHandled = { key: '', at: 0 };
      const shouldSkip = (eventType, id) => {
        if (id == null) return true;
        const key = `${eventType}-${id}`;
        const now = Date.now();
        if (lastHandled.key === key && now - lastHandled.at < DEDUPE_MS) return true;
        lastHandled.key = key;
        lastHandled.at = now;
        return false;
      };
      const listType = 'calibration';
      const isMyType = (p) => p?.type === listType;
      const onCreated = (payload) => {
        if (!isMyType(payload)) return;
        const id = payload?.id;
        if (id == null || shouldSkip('company_certificate.created', id)) return;
        // create changes membership → invalidate progressive session (no addData)
        refreshFromStart();
      };
      const onUpdated = (payload) => {
        if (!isMyType(payload)) return;
        const id = payload?.id;
        if (id == null || shouldSkip('company_certificate.updated', id)) return;
        getRequest(`/api/company_certificates/${id}`).then((res) => {
          const row = res?.data?.data ?? res?.data ?? res;
          if (!row?.id) return;
          const t = getTable();
          let rc = null;
          try {
            rc = t?.getRow?.(row.id) ?? null;
            if (rc === false) rc = null;
          } catch (_e) {
            rc = null;
          }
          if (!rc) {
            const found = t?.getRows?.().find((r) => String(r.getData?.()?.id) === String(id));
            rc = found || null;
          }
          if (row.company_id === currentCompanyId) {
            if (rc && typeof rc.update === 'function') {
              const next = {
                ...row,
                certificate_status: row.deactivation_date ? t('Status.Deactivated') : t('Status.Active'),
              };
              rc.update(next).catch(() => {});
            } else {
              // unloaded row → invalidate (no addData)
              refreshFromStart();
            }
          } else if (rc && typeof rc.delete === 'function') {
            rc.delete();
          }
        }).catch(() => {
          refreshFromStart();
        });
      };
      const onDeleted = (payload) => {
        if (!isMyType(payload)) return;
        const id = payload?.id;
        if (id == null || shouldSkip('company_certificate.deleted', id)) return;
        // delete changes membership → invalidate
        refreshFromStart();
      };
      const refetch = () => { refreshFromStart(); };
      channel.bind('company_certificate.created', onCreated);
      channel.bind('company_certificate.updated', onUpdated);
      channel.bind('company_certificate.deleted', onDeleted);
      channel.bind('company_certificate.activated', refetch);
      channel.bind('company_certificate.deactivated', refetch);
      return () => {
        channel.unbind('company_certificate.created', onCreated);
        channel.unbind('company_certificate.updated', onUpdated);
        channel.unbind('company_certificate.deleted', onDeleted);
        channel.unbind('company_certificate.activated', refetch);
        channel.unbind('company_certificate.deactivated', refetch);
      };
    }, [getTable, currentCompanyId, refreshFromStart]);

    const loadNavigationList = useCallback(() => {
        if (calibration_company?.id == null) return;
        const params = new URLSearchParams();
        params.set('page', '1');
        params.set('size', String(pageSizePc));
        params.set('type', 'calibration');
        params.set('company_id', String(calibration_company.id));
        params.set('sorters', JSON.stringify([{ field: 'id', dir: 'asc' }]));
        getRequest('/api/company_certificates/paged?' + params.toString())
            .then(res => {
                const data = res?.data ?? [];
                setNavigationList(Array.isArray(data) ? data : []);
            })
            .catch(() => setNavigationList([]));
    }, [calibration_company?.id, pageSizePc]);
    useEffect(() => { loadNavigationList(); }, [loadNavigationList]);

    function addNewCalibrationCompanyCertificate(){
        setShowCalibrationCertificateAdd(true);
      }

    function copyCalibrationCompanyCertificate(){
        const row = getTable()?.getSelectedData?.()?.[0];
        if (row) formik.setValues(row);
        setShowCalibrationCertificateAdd(true);
    }

    function editNewCalibrationCompanyCertificate(){
        const row = getTable()?.getSelectedData?.()?.[0];
        if (row) formikUpdate.setValues(row);
        setVisibleCompanyCertificate(true);
    }


    function hideEditCalibrationCompanyCertificate(){
        formikUpdate.resetForm();
        setVisibleCompanyCertificate(false);
    }

    const validate = values => {
        const errors = {};
        return errors;
    };

    const formik = useFormik({
            initialValues:{
                name:'',description:'',deactivation_date:'',required_attachment:true,type:'calibration'},
            enableReinitialize:true,
            validate,
            onSubmit: values => {
                setDialogText(t('Common.Saving'));
                setVisible(true);
                let formData = new FormData();
                formData.append("name", values.name ?? '');
                formData.append("description", values.description ?? '');
                formData.append("deactivation_date", values.deactivation_date ?? '');
                formData.append("required_attachment", values.required_attachment ? '1' : '0');
                formData.append("type", values.type ?? 'calibration');
                formData.append("company_id", calibration_company.id);
                    postRequest('/api/company_certificates', formData,true)
                    .then((response) => {
                        setVisible(false);
                        emitCalibrationCompanyCertStateMutation({
                            kind: CALIBRATION_COMPANY_CERT_KIND.PARENT_CREATED,
                            certificateId: response?.data?.id ?? response?.data?.data?.id,
                            companyId: calibration_company?.id,
                        });
                        getTable()?.replaceData?.();
                        loadNavigationList();
                        if(closeTab)dispatch({type:'close_tab',id:state.selectedTab});
                        setShowCalibrationCertificateAdd(false);
                        formik.resetForm();
                        toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordSavedDetail') });
                        getRequest("/api/companies").then((response) => {
                            dispatch({type:'load_companies',newCompanies:response.data});
                        });
                    }).catch((reason) => {
                        setVisible(false);
                        if(!navigator.online){
                            alert(t('ServiceTask.OfflineQueuedAlert'));
                        }
                        else{
                            alert(t('Common.Toast.ActionFailedDetail'));
                        }
                    })
            },
        });

        const formikUpdate = useFormik({
            initialValues: selectedCertificate == null ? {
                name:'',description:'',deactivation_date:'',responsible_employee_id:'',required_attachment:false,type:'calibration'} : selectedCertificate,
            enableReinitialize:true,
            validate,
            onSubmit: values => {
                setDialogText(t('Common.Saving'));
                setVisible(true);
                let formData = new FormData();
                formData.append("id", formikUpdate.values.id);
                formData.append("name", values.name ?? '');
                formData.append("description", values.description == null || values.description === "null" ? "" : values.description);
                formData.append("deactivation_date", values.deactivation_date ?? '');
                formData.append("responsible_employee_id", (values.responsible_employee_id != null && values.responsible_employee_id !== '') ? values.responsible_employee_id : '');
                formData.append("required_attachment", values.required_attachment ? '1' : '0');
                formData.append("type", values.type ?? 'calibration');
                formData.append("company_id", calibration_company.id);
                postRequest(`/api/company_certificates/update/${formikUpdate.values.id}`, formData,true)
                .then((response) => {
                    setVisible(false);
                    const changedFields = [];
                    if (String(values.name ?? '') !== String(formikUpdate.initialValues?.name ?? '')) changedFields.push('name');
                    if (String(values.description ?? '') !== String(formikUpdate.initialValues?.description ?? '')) changedFields.push('description');
                    if (String(values.deactivation_date ?? '') !== String(formikUpdate.initialValues?.deactivation_date ?? '')) changedFields.push('deactivation_date', 'custom_cert_status');
                    if (Boolean(values.required_attachment) !== Boolean(formikUpdate.initialValues?.required_attachment)) changedFields.push('required_attachment');
                    emitCalibrationCompanyCertStateMutation({
                        kind: CALIBRATION_COMPANY_CERT_KIND.PARENT_UPDATED,
                        certificateId: formikUpdate.values.id,
                        companyId: calibration_company?.id,
                        changedFields,
                    });
                    getTable()?.replaceData?.();
                    loadNavigationList();
                    if(closeTab)dispatch({type:'close_tab',id:state.selectedTab});
                    setVisibleCompanyCertificate(false);
                    formikUpdate.resetForm();
                    toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordSavedDetail') });
                    getRequest("/api/companies").then((response) => {
                        dispatch({type:'load_companies',newCompanies:response.data});
                    });
                }).catch((reason) => {
                    setVisible(false);
                    if(!navigator.online){
                        alert(t('ServiceTask.OfflineQueuedAlert'));
                    }
                    else{
                        alert(t('Common.Toast.ActionFailedDetail'));
                    }
                });
            },
        });

        const formikDeactivation = useFormik({
            initialValues: { deactivation_date: '' },
            enableReinitialize: true,
            onSubmit: values => {
                setDialogText(t('Common.Saving'));
                setVisible(true);
                const rows = getTable()?.getSelectedData?.() ?? [];
                const formData = new FormData();
                rows.forEach((item) => formData.append("certificates[]", item.id));
                formData.append("deactivation_date", values.deactivation_date || new Date().toISOString().slice(0, 10));
                postRequest('/api/company_certificates/deactivate', formData, true)
                    .then(() => {
                        setVisibleDeactivate(false);
                        rows.forEach((item) => emitCalibrationCompanyCertStateMutation({
                            kind: CALIBRATION_COMPANY_CERT_KIND.PARENT_DEACTIVATED,
                            certificateId: item.id,
                            companyId: calibration_company?.id ?? item.company_id,
                        }));
                        formikDeactivation.resetForm();
                        setVisible(false);
                        toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordsUpdatedDetail') });
                        getTable()?.replaceData?.();
                        loadNavigationList();
                        getRequest("/api/companies").then((r) => dispatch({ type: 'load_companies', newCompanies: r.data }));
                    })
                    .catch((reason) => {
                        setVisible(false);
                        setVisibleDeactivate(false);
                        alert(reason);
                        toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.RecordUpdateFailedDetail'), life: 3000 });
                    });
            },
        });

    const { scrollToFirst, scrollUp, scrollDown, scrollToLast } = useMemo(
        () => createArrayNavigateHandlers(navigationList, formik.values.id, setFormCalibrationCompanyCertificate),
        [navigationList, formik.values.id]
    );

    const onSelectRow = () => {
        setEditIcon(true);
        setCopyIcon(true);
        setDeleteIcon(true);
        setDeactivateIcon(true);
        setActivateIcon(true);
        const selected = getTable()?.getSelectedData?.() ?? [];
        if(selected.length === 1){
            if(user.permissions?.includes("edit calibration-company"))setEditIcon(false);
            if(user.permissions?.includes("delete calibration-company"))setDeleteIcon(false);
            if(user.permissions?.includes("add calibration-company"))setCopyIcon(false);
            if(user.permissions?.includes("edit calibration-company")){
                const row = selected[0];
                if(!row.deactivation_date || row.deactivation_date === '') setDeactivateIcon(false);
                else setActivateIcon(false);
            }
            setSelectedCertificate(selected[0]);
        } else if(selected.length > 1){
            let activated = 0, deactivated = 0;
            selected.forEach(item => {
                if(!item.deactivation_date || item.deactivation_date === '') activated++;
                else deactivated++;
            });
            if(activated && !deactivated) setDeactivateIcon(false);
            else if(deactivated && !activated) setActivateIcon(false);
        }
    }

      function onEditRow(certificate){
        formikUpdate.setValues(certificate);
        setSelectedCertificate(certificate);
        setVisibleCompanyCertificate(true);
    };

    function EditRowFormatter(props) {
        const rowData = props.cell.getRow().getData();
        return <div className='flex items-center justify-center w-full h-full'><button type='button' onClick={() => onEditRow(rowData)}><EditRowIcon/></button></div>;
    }

    function DeactivationDateFormatter(props) {
        const rowData = props.cell.getRow().getData();
        const d = rowData?.deactivation_date;
        return <span>{d ? DateTime.fromISO(d).toFormat(dateFmt) : '—'}</span>;
    }

    function auditDateText(raw) {
        if (raw == null || raw === '') return '';
        if (formatDate) {
            const text = formatDate(raw, dateTimeFmt, true);
            return text || '';
        }
        const dt = DateTime.fromISO(String(raw));
        return dt.isValid ? dt.toFormat(dateTimeFmt) : '';
    }

    function CreatedAtFormatter(props) {
        const rowData = props.cell.getRow().getData();
        const u = rowData?.created_by_user;
        const displayName = u?.employee?.name || u?.username || '';
        const text = auditDateText(rowData?.created_at);
        return (
            <div className="flex items-center justify-start w-full h-full min-w-0 gap-1">
                {u ? (
                    <Avatar
                        className="shrink-0"
                        title={displayName}
                        label={getUserInitials?.(displayName) || ''}
                        shape="circle"
                        style={{ backgroundColor: getUserColor?.(u?.username) || '#6b7280', color: '#ffffff' }}
                    />
                ) : null}
                <div className="min-w-0 flex-1 truncate whitespace-nowrap" title={text || undefined}>{text}</div>
            </div>
        );
    }

    function UpdatedAtFormatter(props) {
        const rowData = props.cell.getRow().getData();
        const u = rowData?.updated_by_user;
        const displayName = u?.employee?.name || u?.username || '';
        const text = auditDateText(rowData?.updated_at);
        return (
            <div className="flex items-center justify-start w-full h-full min-w-0 gap-1">
                {u ? (
                    <Avatar
                        className="shrink-0"
                        title={displayName}
                        label={getUserInitials?.(displayName) || ''}
                        shape="circle"
                        style={{ backgroundColor: getUserColor?.(u?.username) || '#6b7280', color: '#ffffff' }}
                    />
                ) : null}
                <div className="min-w-0 flex-1 truncate whitespace-nowrap" title={text || undefined}>{text}</div>
            </div>
        );
    }

    const [columns,setColumns] = useState([
      { title: '', field: 'id',formatter:"rowSelection", titleFormatter:"rowSelection", hozAlign:"center", width: 44, headerSort:false},
      { title: '', field: 'editor',hozAlign:"center", width: 44, headerSort:false,formatter: reactFormatter(<EditRowFormatter/>),resizable:false},
      { title: t('Common.Name'), field: 'name',headerFilter:"input", minWidth: 200},
      { title: t('Common.Deactivation'), field: 'deactivation_date',headerFilter:"input", minWidth: 180, formatter: reactFormatter(<DeactivationDateFormatter/>)},
      { title: t('Calibration.CertificateStatus'), field: 'certificate_status', headerFilter:"list", headerFilterParams:{ values:{[t('Status.Active')]:t('Status.Active'),[t('Status.Deactivated')]:t('Status.Deactivated')}, clearable:true }, minWidth: 200},
      { title: t('Common.Column.Responsible'), field: 'responsible.name',headerFilter:"input", minWidth: 260, widthGrow:1},
      { title: t('Common.MandatoryAttachment'), field: 'required_attachment', headerFilter:"list", headerFilterParams:{ values:{["Áno"]: t('Common.Yes'),["Nie"]: t('Common.No')}, clearable:true }, minWidth: 220, formatter: (cell) => cell.getValue() ? t('Common.Yes') : t('Common.No')},
      { title: t('Common.Description'), field: 'description',headerFilter:"input", minWidth: 200, widthGrow:1.2},
      { title: t('Common.Column.CreatedAt'), field: 'created_at', minWidth: 220, formatter: reactFormatter(<CreatedAtFormatter/>), headerSort: true},
      { title: t('Common.Column.UpdatedAt'), field: 'updated_at', minWidth: 220, formatter: reactFormatter(<UpdatedAtFormatter/>), headerSort: true},
    ]);

    function setMask(item,value){
        const columnVisible = {...columnsVisible};
        columnVisible[item] = value;
        for(const val in columnVisible) {
          if(columnVisible[val]==false){
            getTable()?.hideColumn?.(`${val}`);
          }
          else{
            getTable()?.showColumn?.(`${val}`);
          }
        }
        setColumnsVisible(columnVisible);
      }

      const resetMask = () => resetTabulatorMask({
        page: 'CalibrationCompanyCardDetail',
        defaultColumnsVisible: DEFAULT_COLUMNS_VISIBLE_CALIBRATION_COMPANY,
        ref,
        columns,
        setColumnsVisible,
      });

      const itemRenderer = (item, options) => (
        <a className="flex align-items-center px-3 py-2 cursor-pointer items-center bg-[#333] text-white w-[180px]" onClick={options.onClick}>
            <span className={`${item.icon} text-primary`} />
            <span className={`mx-2 ${item.items && 'font-semibold'}`}>{item.label}</span>
            {item.shortcut && <span className="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">{item.shortcut}</span>}
        </a>
      );

      const [expandedKeys, setExpandedKeys] = useState({});

      const handleClickOutside = (event) => {
        if (overlayRef.current && !overlayRef.current.contains(event.target)) {
            setExpandedKeys({});
        }
      };

      useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);

      const items = [
      {
        key: '0',
        label: t('Common.Actions'),
        icon: 'pi pi-sliders-v',
        template: itemRenderer,
        items: [
            {
                key: '0_1',
                label: t('Common.SetFilter'),
                icon: 'pi pi-filter',
                command: () => {setUserMaskFilter("CalibrationCompanyCardDetail","set_filters",null,getTable()?.getHeaderFilters?.() ?? [],null);captureHScroll();getTable()?.replaceData?.();},
                template: itemRenderer,
            },
              {
                key: '0_2',
                label: t('Common.ClearFilter'),
                icon: 'pi pi-filter-slash',
                command: () => {setUserMaskFilter("CalibrationCompanyCardDetail","set_filters",null,[],null);getTable()?.clearHeaderFilter?.();captureHScroll();getTable()?.replaceData?.();},
                template: itemRenderer,
            },
            {
                key: '0_3',
                label: t('Common.SetSorting'),
                icon: 'pi pi-sort-alt',
                command: () => {setUserMaskFilter("CalibrationCompanyCardDetail","set_sorters",null,null,null,getTable()?.getSorters?.() ?? []);OverflowMenuProvider.setVisible(null);setExpandedKeys({});captureHScroll();getTable()?.replaceData?.();},
                template: itemRenderer,
            },
            {
                key: '0_4',
                label: t('Common.ClearSorting'),
                icon: 'pi pi-sort-alt-slash',
                command: () => {setUserMaskFilter("CalibrationCompanyCardDetail","set_sorters",null,null,null,[]);getTable()?.setSort?.([]);OverflowMenuProvider.setVisible(null);setExpandedKeys({});captureHScroll();getTable()?.replaceData?.();},
                template: itemRenderer,
            },
            {
                key: '0_5',
                label: t('Common.SetMask'),
                icon: 'pi pi-server',
                command: () => {setMaskVisible(true);OverflowMenuProvider.setVisible(null);setExpandedKeys({});},
                template: itemRenderer,
            },
            {
              key: '0_5b',
              label: t('Common.ResetUserMask'),
              icon: 'pi pi-refresh',
              command: () => { resetMask(); OverflowMenuProvider.setVisible(null); setExpandedKeys({}); },
              template: itemRenderer,
            },
            {
              key: '0_6',
              label: t('Common.Notifications'),
              icon: 'pi pi-envelope',
              command: () => {openChosenNotificationPreferences('CalibrationCompanyCardDetail');OverflowMenuProvider.setVisible(null);},
              template: itemRenderer,
          },
        ]
      }
    ];function changeMarkings(value){
        if(value){
          const columnVisible = {...columnsVisible};
          for(let val in columnVisible) {
            if(columnVisible[val]!=="id" || columnVisible[val]!=="editor" || columnVisible[val]!=="end_of_validity"){
              columnVisible[val]=true;
              getTable()?.showColumn?.(`${val}`);
            }
          };
          setColumnsVisible(columnVisible);
        }
        else{
          const columnVisible = {...columnsVisible};
          for(let val in columnVisible) {
            if(columnVisible[val]!=="id" || columnVisible[val]!=="editor"|| columnVisible[val]!=="end_of_validity"){
              columnVisible[val]=false;
              getTable()?.hideColumn?.(`${val}`);
            }
          };
          setColumnsVisible(columnVisible);
        }
      }

      const reject = () => {
          toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.RequestCancelled'), life: 3000 });
      }

    const acceptCertificate = () => {
            setDialogText(t('Common.DeletingShort'));
            setVisible(true);
            let rows_to_delete = getTable()?.getSelectedData?.() ?? [];
            var itemsProcessed = 0;
            const total = rows_to_delete.length;
            rows_to_delete.forEach((item) => {
              deleteRequest(`/api/company_certificates/${item.id}`)
                  .then((response) => {
                    itemsProcessed++;
                    emitCalibrationCompanyCertStateMutation({
                        kind: CALIBRATION_COMPANY_CERT_KIND.PARENT_DELETED,
                        certificateId: item.id,
                        companyId: calibration_company?.id ?? item.company_id,
                    });
                    toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordDeletedDetail') });
                    if(itemsProcessed === total) {
                        setVisible(false);
                        getTable()?.replaceData?.();
                        loadNavigationList();
                        getRequest("/api/companies").then((response) => {
                            dispatch({type:'load_companies',newCompanies:response.data});
                        });
                    }
                  }).catch((reason) => {
                      setVisible(false);
                      alert(reason);
                      toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.DeleteFailedDetail'), life: 3000 });
                  })
            });
        }

      const confirm = () => {
        confirmDialog({
            message: t('Common.ConfirmDeleteRecord'),
            header: t('Common.ConfirmDelete'),
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            acceptLabel: t('Common.No'),
            rejectLabel: t('Common.Yes'),
            accept: reject,
            reject: acceptCertificate
        });
    };

    const acceptActivate = () => {
        setDialogText(t('Common.Saving'));
        setVisible(true);
        const rows = getTable()?.getSelectedData?.() ?? [];
        const formData = new FormData();
        rows.forEach((item) => formData.append("certificates[]", item.id));
        postRequest('/api/company_certificates/activate', formData, true)
            .then(() => {
                setVisible(false);
                rows.forEach((item) => emitCalibrationCompanyCertStateMutation({
                    kind: CALIBRATION_COMPANY_CERT_KIND.PARENT_ACTIVATED,
                    certificateId: item.id,
                    companyId: calibration_company?.id ?? item.company_id,
                }));
                toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordsActivatedDetail') });
                getTable()?.replaceData?.();
                loadNavigationList();
                getRequest("/api/companies").then((r) => dispatch({ type: 'load_companies', newCompanies: r.data }));
            })
            .catch((reason) => {
                setVisible(false);
                alert(reason);
                toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.RecordActivateFailedDetail'), life: 3000 });
            });
    };

    const confirmActivate = () => {
        confirmDialog({
            message: t('Common.ConfirmActivateCertificates'),
            header: t('Common.ConfirmActivation'),
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            acceptLabel: t('Common.No'),
            rejectLabel: t('Common.Yes'),
            accept: reject,
            reject: acceptActivate
        });
    };

    return (
        <>
            <div>
            <div className='w-full h-10 flex flex-row bg-[#333]'>
            <IntersectionObserverWrapper>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="add"><button className="disabled:opacity-25" disabled={insertCopyIcon} onClick={() => addNewCalibrationCompanyCertificate()}><AddIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="copy"><button className="disabled:opacity-25" disabled={copyIcon} onClick={() => copyCalibrationCompanyCertificate()}><CopyIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="edit"><button className="disabled:opacity-25" disabled={editIcon} onClick={() => editNewCalibrationCompanyCertificate()}><EditIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="delete"><button className="disabled:opacity-25" disabled={deleteIcon} onClick={confirm}><DeleteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="activate"><button className="disabled:opacity-25" disabled={activateIcon} onClick={confirmActivate}><ActivateIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="deactivate"><button className="disabled:opacity-25" disabled={deactivateIcon} onClick={() => setVisibleDeactivate(true)}><DeactivateIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="first"><button className="disabled:opacity-25" onClick={() => scrollToFirst()} disabled={scrollIcons || !navigationList?.length} title={t('Common.FirstRecord')}><BackToFirstIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="back"><button className="disabled:opacity-25" onClick={() => scrollUp()} disabled={scrollIcons || !navigationList?.length} title={t('Common.Previous')}><BackIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="forward"><button className="disabled:opacity-25" onClick={() => scrollDown()} disabled={scrollIcons || !navigationList?.length} title={t('Common.Next')}><ForwardIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="last"><button className="disabled:opacity-25" onClick={() => scrollToLast()} disabled={scrollIcons || !navigationList?.length} title={t('Common.LastRecord')}><ForwardToLastIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="favorite"><button className="disabled:opacity-25" disabled onClick={() => openFavoriteDialog(t('Calibration.CompanyCerts'), "CalibrationCompanyCardDetail")}><FavoriteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="price"><button className="disabled:opacity-25" disabled onClick={() => setFastView("CalibrationCompanyCardDetail",columnsVisible,columns)}><PriceIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
          <div className="card flex justify-content-center z-[100]" data-targetid="actions" ref={overlayRef}>
            <PanelMenu model={items} expandedKeys={expandedKeys} onExpandedKeysChange={setExpandedKeys} className="w-full md:w-20rem"/>
          </div>
          </IntersectionObserverWrapper>
        </div>
        <Splitter className='h-[calc(100vh_-_177px)]' layout="vertical" pt={{ gutter: { className: 'bg-[#333] h-8' },gutterHandler: { className: 'bg-secondary ' } }}>
        <SplitterPanel className="flex align-items-center justify-content-center overflow-y-auto " minSize={10} size={63}>
        <div className="w-full relative flex flex-col h-full overflow-x">
          <div className='xl:grid grid-cols-2 gap-1 mb-2 '>
            <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                <h1 className="text-3xl font-semibold text-left text-zinc-900">{t('Ui.R67.CERTIFIKATY_KALIBRACNEJ_FIRMY')}</h1>
                {formType=="edit" && <label className="block text-md font-semibold text-gray-800">Por.č.: {formik.values.id}</label>}
                      <div>
                        <label
                            htmlFor="name"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Ui.R67.NAZOV_KALIBRACNEJ_FIRMY')}</label>
                        <input
                        readOnly={true}
                            name='name'
                            type="text"
                            value={company?.name ?? ''}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="tel_number"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.PhoneNumber')}</label>
                        <input
                        readOnly={true}
                            name='tel_number'
                            type="text"
                            value={company?.tel_number ?? ''}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="email"
                            className="block text-md font-semibold text-gray-800"
                        >
                            E-MAIL
                        </label>
                        <input
                        readOnly={true}
                            name='email'
                            type="text"
                            value={company?.email ?? ''}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="contact_person"
                            className="block text-md font-semibold text-gray-800 mt-2"
                        >{t('Common.ContactPersonUpper')}</label>
                        <input
                        readOnly={true}
                            name='contact_person'
                            type="text"
                            value={company?.contact_person ?? ''}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        {selectedCertificate != null && (
                        <div>
                        <label className="block text-md font-semibold text-gray-800 mt-2">POVINNÁ PRÍLOHA (vybraný certifikát)</label>
                        <input type="text" readOnly value={selectedCertificate?.required_attachment ? t('Common.Yes') : t('Common.No')} className="block w-full px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md" />
                        </div>
                        )}
            </div>
            <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                    <div>
                        <label
                            htmlFor="address"
                            className="block text-md font-semibold text-gray-800"
                        >
                            ADRESA
                        </label>
                        <input
                        readOnly={true}
                            name='address'
                            type="text"
                            value={company?.address ?? ''}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="fax"
                            className="block text-md font-semibold text-gray-800"
                        >
                             FAX
                        </label>
                        <input
                        readOnly={true}
                            name='fax'
                            type="text"
                            value={company?.fax ?? ''}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="web_address"
                            className="block text-md font-semibold text-gray-800"
                        >
                            WEB. ADRESA
                        </label>
                        <input
                        readOnly={true}
                            name='web_address'
                            type="text"
                            value={company?.web_address ?? ''}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="description"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.NoteUpper')}</label>
                        <textarea
                        readOnly={true}
                            name='description'
                            type="text"
                            value={company?.description ?? ''}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        >
                        </textarea>
                        </div>
            </div>
            </div>
            </div>
             </SplitterPanel>
             <SplitterPanel className="flex flex-col align-items-center justify-content-center w-full overflow-y-auto" size={37} style={{minHeight: '110px'}}>
             <ReactTabulator
               data={undefined}
               className='h-[calc(100vh_-_176px)]'
               onRef={(r) => (ref.current = r.current)}
               columns={columns}
               events={{
                 rowSelectionChanged: onSelectRow,
                 headerFilterChanged: () => { captureHScroll(); getTable()?.replaceData?.(); },
                 renderComplete: () => restoreHScroll(),
                 tableBuilt: () => {
                    let mask = (state.user_mask_filters || []).filter(mask => mask.page=="CalibrationCompanyCardDetail");
                    const safeParse = (v, fallback) => {
                        if (v === null || v === undefined) return fallback;
                        if (typeof v === "string") {
                        try { return JSON.parse(v); } catch { return fallback; }
                        }
                        return v;
                    };
                    if (mask.length > 0) {
                        const t = getTable();
                        const attributes  = safeParse(mask[0].attributes, []);
                        const filters     = safeParse(mask[0].filters, []);
                        const sorters     = safeParse(mask[0].sorters, []);
                        const json_columns = safeParse(mask[0].columns, {});
                        if (Array.isArray(attributes) && attributes.length > 1) {
                            t?.setColumnLayout?.(attributes);
                        }
                        if (Array.isArray(filters)) {
                            filters.forEach(f => t?.setHeaderFilterValue?.(f.field, f.value));
                        }
                        if (Array.isArray(sorters) && sorters.length > 0) {
                            t?.setSort?.(sorters);
                        }
                        if (json_columns && typeof json_columns === "object") {
                            setColumnsVisible(json_columns);
                            for (let column in json_columns) {
                                if (json_columns[column] === false) t?.hideColumn?.(column);
                                else t?.showColumn?.(column);
                            }
                        }
                        refreshFromStart();
                    }
                  },
                 columnMoved:() => {
                   setUserMaskFilter("CalibrationCompanyCardDetail","column_move",null,null,getTable()?.getColumnLayout?.());
                 },
                 columnResized: () => {
                   setUserMaskFilter("CalibrationCompanyCardDetail", "column_resized", null, null, getTable()?.getColumnLayout?.());
                 }
               }}
               options={{
                 renderHorizontal:"virtual",layout:"fitColumns",movableColumns: true,rowHeight:30,
                 printAsHtml:true,
                 printHeader: () => buildCanonicalPrintHeaderHtml({
                   branding: state?.branding,
                   productFallbackSrc: defaultProductLogoSrc,
                   companySettingsPrint: state?.company_settings_print,
                   moduleSettings: state?.module_settings,
                   title: t('Print.Title.CalibrationCompanyCerts'),
                   printDateLabel: t('Print.DateLabel'),
                 }),
                 printFooter: () => buildCanonicalPrintFooterHtml({ companySettingsPrint: state?.company_settings_print }),
                 printRowRange:"active",
                 autoResize:false,
                 ajaxURL: '/api/company_certificates/paged',
                 ajaxRequestFunc,
                 filterMode: 'remote',
                 progressiveLoad: 'scroll',
                 progressiveLoadScrollMargin: 80,
                 paginationSize: pageSizePc,
                 pagination: false,
                 dataLoader: true,
                 dataLoaderLoading: t('Common.LoadingEllipsis'),
                 dataLoaderError: t('Common.LoadFailed'),
               }}/>
            </SplitterPanel>
            </Splitter>
            </div>
            <Dialog header={t('Calibration.AddCertificate')} visible={showCalibrationCertificateAdd} style={{ width: '40vw' }} onHide={() => setShowCalibrationCertificateAdd(false)}>
            <form onSubmit={formik.handleSubmit}>
            <div>
                <div>
                    <label
                        htmlFor="name"
                        className="block text-md font-semibold text-gray-800"
                    >{t('Common.Name')}</label>
                    <input
                        name='name'
                        type="text"
                        onChange={formik.handleChange} value={formik.values.name}
                        className="block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                    />
                </div>
                <div className="mt-2">
                    <label htmlFor="deactivation_date" className="block text-md font-semibold text-gray-800">{t('Common.Deactivation')}</label>
                    <input
                        name="deactivation_date"
                        type="date"
                        onChange={formik.handleChange}
                        value={formik.values.deactivation_date ?? ''}
                        className="block w-full px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                    />
                </div>
                <div className="mt-2">
                    <label htmlFor="responsible_employee_id" className="block text-md font-semibold text-gray-800">{t('Common.ResponsiblePerson')}</label>
                    <Dropdown
                        value={formik.values.responsible_employee_id}
                        onChange={(e) => formik.setFieldValue('responsible_employee_id', e.value)}
                        options={state.employees?.filter(emp => !emp.date_of_departure || emp.date_of_departure === '')?.map(emp => ({ name: emp.name, id: emp.id })) ?? []}
                        optionLabel="name"
                        optionValue="id"
                        showClear
                        filter
                        placeholder={t('Common.SelectEmployee')}
                        className="w-full mt-2 border border-gray-300 rounded-md"
                    />
                </div>
                <div className="mt-2 flex align-items-center gap-2">
                    <Checkbox inputId="required_attachment_add" checked={!!formik.values.required_attachment} onChange={(e) => formik.setFieldValue('required_attachment', e.checked)} />
                    <label htmlFor="required_attachment_add" className="text-md font-semibold text-gray-800">{t('Common.MandatoryAttachment')}</label>
                </div>
                <div className="mt-2">
                    <label htmlFor='description' className='font-bold text-black'>{t('Common.Description')}</label>
                    <input
                    name='description'
                    type='text'
                    onChange={formik.handleChange} value={formik.values.description}
                    className="block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
                </div>
            </div>
            <button type="submit" className='flex justify-center items-center mt-4 w-full h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600 disabled:opacity-25'>{t('Common.SaveState')}</button>
            </form>
            </Dialog>
            <Dialog header={t('Calibration.EditCertificate')} visible={visibleCompanyCertificate} style={{ width: '40vw' }} onHide={() => hideEditCalibrationCompanyCertificate()}>
    <form onSubmit={formikUpdate.handleSubmit}>
    <div>
                <div>
                <label htmlFor="name" className="block text-md font-semibold text-gray-800">{t('Common.Name')}</label>
                <input
                    name='name'
                    type="text"
                    onChange={formikUpdate.handleChange} value={formikUpdate.values.name}
                    className="block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                />
                </div>
                <div className="mt-2">
                    <label htmlFor="deactivation_date" className="block text-md font-semibold text-gray-800">{t('Common.Deactivation')}</label>
                    <input
                        name="deactivation_date"
                        type="date"
                        onChange={formikUpdate.handleChange}
                        value={formikUpdate.values.deactivation_date ?? ''}
                        className="block w-full px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                    />
                </div>
                <div className="mt-2">
                    <label htmlFor="responsible_employee_id" className="block text-md font-semibold text-gray-800">{t('Common.ResponsiblePerson')}</label>
                    <Dropdown
                        value={formikUpdate.values.responsible_employee_id}
                        onChange={(e) => formikUpdate.setFieldValue('responsible_employee_id', e.value)}
                        options={state.employees?.filter(emp => !emp.date_of_departure || emp.date_of_departure === '')?.map(emp => ({ name: emp.name, id: emp.id })) ?? []}
                        optionLabel="name"
                        optionValue="id"
                        showClear
                        filter
                        placeholder={t('Common.SelectEmployee')}
                        className="w-full mt-2 border border-gray-300 rounded-md"
                    />
                </div>
                <div className="mt-2 flex align-items-center gap-2">
                    <Checkbox inputId="required_attachment_edit" checked={!!formikUpdate.values.required_attachment} onChange={(e) => formikUpdate.setFieldValue('required_attachment', e.checked)} />
                    <label htmlFor="required_attachment_edit" className="text-md font-semibold text-gray-800">{t('Common.MandatoryAttachment')}</label>
                </div>
                <div className="mt-2">
                    <label htmlFor='description' className='font-bold text-black'>{t('Common.Description')}</label>
                    <input
                    name='description'
                    type='text'
                    onChange={formikUpdate.handleChange} value={formikUpdate.values.description}
                    className="block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
                </div>
            </div>
            <button type="submit" className='flex justify-center items-center mt-4 w-full h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600 disabled:opacity-25'>{t('Common.SaveState')}</button>
            </form>
      </Dialog>
      <Dialog header={t('Calibration.DeactivateCertificates')} visible={visibleDeactivate} style={{ width: '40vw' }} onHide={() => setVisibleDeactivate(false)}>
            <form onSubmit={formikDeactivation.handleSubmit}>
              <div className="flex flex-columns justify-between">
                <label className="block text-md font-semibold text-gray-800">{t('Util.FilePreview.MsgDate')}</label>
                <input
                    value={formikDeactivation.values.deactivation_date}
                    onChange={formikDeactivation.handleChange}
                    name="deactivation_date"
                    type="date"
                    required
                    className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                />
                <button type="submit" className="mt-4 px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600">{t('Ui.R67.VYKONAT')}</button>
              </div>
            </form>
      </Dialog>
      <Dialog header={t('Common.SetMask')} visible={maskVisible} style={{ width: '70vw' }} onHide={() => setMaskVisible(false)}>
        <div className="flex flex-col">
        <button type="button" onClick={() => {changeMarkings(!markUnmark);setMarkUnmarked(!markUnmark);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-700 rounded-md hover:bg-zinc-500'>{markUnmark ? t('Common.DeselectAllUpper') : t('Common.SelectAllUpper')}</button>
        {columns.map(function(item, index){
          if(index<2 || index>7) return null;
                    return <div
                        key={index}
                        className="flex flex-row border border-black rounded-md p-2 m-1"
                    >

                         <Checkbox onChange={(e) => setMask(item.field,e.checked)} checked={columnsVisible[item.field]}></Checkbox><span className="ml-2">{item.title}</span>

                    </div>
                })}
            <button onClick={() => {setUserMaskFilter("CalibrationCompanyCardDetail","set_columns",columnsVisible,null,null);setMaskVisible(false);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'>{t('Ui.R67.SaveUpper')}</button>
        </div>
      </Dialog>
        
            </>
            );
}
